import React from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const CardPartner = ({ partner }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClickPartner = (id) => {
    navigate(`/partner-details/${id}`);
  };

  return (
    <div
      className="z-10 w-full  py-6 px-2 flex flex-col cursor-pointer group duration-200"
      onClick={() => onClickPartner(partner.id)}
    >
      <div className="w-full sm:min-w-[330px] rounded-[1.25rem] overflow-hidden relative flex justify-center ">
        <img
          src={partner.logo}
          alt={partner.name}
          className="w-[330px] h-[330px]  group-hover:scale-110 group-hover:-translate-x-[10px] group-hover:-translate-y-[10px] transition-transform duration-[400ms]"
        />
        <div className="absolute opacity-0 bottom-0 right-0 bg-secondary1 w-[70px] translate-y-10 h-[70px] flex justify-center items-center rounded-tl-[1.25rem] group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 transition-all duration-[400ms]">
          <Icon
            icon="ic:baseline-plus"
            style={{ fontWeight: 600 }}
            className="w-[28px] h-[28px] text-white"
          ></Icon>
        </div>
      </div>
      <div className="py-4 flex flex-col w-full">
        <div className="w-fit text-primary_light text-wrap">{partner.name}</div>

        <div className="flex gap-2">
          {partner.type.map((item, index) => {
            return (
              <div key={index} className="text-[0.875rem]  text-primary ">
                <p className="">{t(item)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CardPartner;
